import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NgxSpinnerService } from "ngx-spinner";
import * as CryptoJS from 'crypto-js';
import { CookieService } from 'ngx-cookie-service';
import {  BehaviorSubject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { FormGroup } from '@angular/forms';
import Swal from 'sweetalert2/src/sweetalert2.js'
import { DatePipe } from '@angular/common';
import { CommonVariablesService } from './common-variables.service';

@Injectable({
	providedIn: 'root'
})
export class CommonService {
	idToRoutePolicyConfig: number = 0;
	declarationHeader: any = {};
	declarationEndorsement: any = 'marinecoi-certificateendorsement';
	declarationPremiumEndorsement: any = 'marinecoi-certificatepremiumendorsement';
	isGcHavingEndorsement: boolean = false;

	//modalRef: BsModalRef;
	responseMethod: any;
	pincodePattern = /[0-9]/;
	numberPattern = /[0-9\.]/;
	alphaNumbericPattern = /[a-zA-Z0-9]/;
	freeTextPattern = /^[ A-Za-z0-9_@$./\*{},=#&+\-();'\[\] ]*$/;
	alphaNumbericWithSpacePattern = /[a-zA-Z0-9 ]/;
	keystobepassedout = '$Backspace$Delete$Home$Tab$ArrowLeft$ArrowRight$ArrowUp$ArrowDown$End$';
	objectSelector = new BehaviorSubject<any>('');
	asObservable = this.objectSelector.asObservable();
	tokenExpiredCount = 0;
	risk_details:any;
	gcPolicyList: any = [];
	constructor(
		private httpClient: HttpClient,
		private router: Router,
		private spinner: NgxSpinnerService,
		private cookie: CookieService,
		private toastr: ToastrService,
		public commonVariablesService: CommonVariablesService,
		private datePipe: DatePipe) { }

	passValue(data) {
		this.objectSelector.next(data);
	}

	/*
	* Created By : Dinesh kumar
	* Description : Used to encrypt the token data.
	*********************************************/
	encryptData(data) {
		let encryptSecretKey = sessionStorage.getItem('token');
		/* let encryptSecretKey = window.localStorage.getItem('token'); */
		try {
			return CryptoJS.AES.encrypt(JSON.stringify(data), encryptSecretKey).toString();
		}
		catch (e) {
		}
	}
	/*
	* Created By : Dinesh kumar
	* Description : Used to decrypt the token data.
	*********************************************/
	decryptData(data) {
		let encryptSecretKey = sessionStorage.getItem('token');
		/* let encryptSecretKey = window.localStorage.getItem('token'); */
		try {
			let bytes = CryptoJS.AES.decrypt(data, encryptSecretKey).toString(CryptoJS.enc.Utf8);
			return JSON.parse(bytes);
		}
		catch (e) {
		}
	}

	/*
	* Created By :PriyaDharshini M
	* Description : Get the data from server and returns it.
	*********************************************/
	httpGetMethod(url: string, contentType: string, token: boolean, parameter: any, moduleName: string, isImpersonate: boolean = false) {
		let options: any;
		let tokenId: string = ''; //token Value
		if (token) {
			tokenId = (isImpersonate) ? sessionStorage.getItem('imp_token') : sessionStorage.getItem('token');
			options = {
				headers: new HttpHeaders({
					'Content-Type': contentType,
					'in-auth-token': tokenId
				}),
				observe: 'response',
				params: parameter
			};
		}
		else {
			options = {
				headers: new HttpHeaders({
					'Content-Type': contentType
				}),
				observe: 'response',
				params: parameter
			};
		}

		return this.getResponse('get', url, options, parameter, moduleName);
	}

	/*
	* Created By :PriyaDharshini M
	* Description : Post the data to server.
	*********************************************/
	httpPostMethod(url: string, parameter: any, contentType: string, token: boolean, moduleName: string, isImpersonate: boolean = false) {
		let options: any;
		let tokenId: string = '';
		if (token && contentType != '') {
			/* tokenId = (isImpersonate) ? sessionStorage.getItem('imp_token') : sessionStorage.getItem('token'); */
			/* tokenId = (isImpersonate) ? window.localStorage.getItem('imp_token') : window.localStorage.getItem('token'); */
			tokenId = (isImpersonate) ? sessionStorage.getItem('imp_token') : sessionStorage.getItem('token');
			options = {
				headers: new HttpHeaders({
					'Content-Type': contentType,
					'in-auth-token': tokenId
				}),
				observe: 'response'
			};
		}
		else if (token && contentType == '') {
			/* tokenId = (isImpersonate) ? sessionStorage.getItem('imp_token') : sessionStorage.getItem('token'); */
			/* tokenId = (isImpersonate) ? window.localStorage.getItem('imp_token') : window.localStorage.getItem('token'); */
			tokenId = (isImpersonate) ? sessionStorage.getItem('imp_token') : sessionStorage.getItem('token');
			options = {
				headers: new HttpHeaders({
					'in-auth-token': tokenId
				}),
				observe: 'response'
			};
		}
		else {
			options = {
				headers: new HttpHeaders({
					'Content-Type': contentType
				}),
				observe: 'response'
			};
		}

		return this.getResponse('post', url, options, parameter, moduleName);
	}

	/*
	* Created By : Dinesh kumar
	* Description : For Updating and deleting the users .
	*********************************************/
	httpPutMethod(url: string, parameter: any, contentType: string, token: boolean, moduleName: string, isImpersonate: boolean = false) {
		let options: any;
		let tokenId: string = '';
		if (token) {
			/* tokenId = (isImpersonate) ? sessionStorage.getItem('imp_token') : sessionStorage.getItem('token'); */
			/* tokenId = (isImpersonate) ? window.localStorage.getItem('imp_token') : window.localStorage.getItem('token'); */
			tokenId = (isImpersonate) ? sessionStorage.getItem('imp_token') : sessionStorage.getItem('token');
			options = {
				headers: new HttpHeaders({
					'Content-Type': contentType,
					'in-auth-token': tokenId
				}),
				observe: 'response'
			};
		}
		else {
			options = {
				headers: new HttpHeaders({
					'Content-Type': contentType
				}),
				observe: 'response'
			};
		}

		return this.getResponse('put', url, options, parameter, moduleName);
	}

	/*
	* Created By : Manasa R
	* Description : For  deleting the users with in group.
	*********************************************/
	httpDeleteMethod(url: string, contentType: string, token: boolean, moduleName: string, isImpersonate: boolean = false) {
		let options: any;
		let tokenId: string = '';
		if (token) {
			/* tokenId = (isImpersonate) ? sessionStorage.getItem('imp_token') : sessionStorage.getItem('token'); */
			/* tokenId = (isImpersonate) ? window.localStorage.getItem('imp_token') : window.localStorage.getItem('token'); */
			tokenId = (isImpersonate) ? sessionStorage.getItem('imp_token') : sessionStorage.getItem('token');
			options = {
				headers: new HttpHeaders({
					'Content-Type': contentType,
					'in-auth-token': tokenId
				}),
				observe: 'response'
			};
		}
		else {
			options = {
				headers: new HttpHeaders({
					'Content-Type': contentType
				}),
				observe: 'response'
			};
		}

		return this.getResponse('delete', url, options, '', moduleName);
	}
	/*
	* Created By : Dinesh kumar
	* Description : getting response based on the type of method.
	*********************************************/

	async getResponse(methodName, url, options, parameter, moduleName) {
		const uwLevelUrl = `${this.commonVariablesService.baseURL}api/v1/transact/userLevel`;
		const gcPolicyUrl = `${this.commonVariablesService.baseURL}api/v1/marine_declaration/master_policy`;
		const proposalUrl = `${this.commonVariablesService.baseURL}api/v1/proposal`;
		const eproposalFinalizeUrl = `${this.commonVariablesService.baseURL}api/v2/eproposal/finalize`;
		// if (url == uwLevelUrl || url == gcPolicyUrl || (url == proposalUrl  && moduleName == 'Declaration') || (url == eproposalFinalizeUrl  && moduleName == 'Declaration')) {
		if (url == uwLevelUrl || (url == proposalUrl  && moduleName == 'Declaration') || (url == eproposalFinalizeUrl  && moduleName == 'Declaration')) {
			setTimeout(() => {
				this.spinner.show();
			}, 2000);
		}

		this.responseMethod = null;
		if (methodName == 'get'){
			if (url == gcPolicyUrl) {
				// setTimeout(() => {
				// 	this.spinner.show();
				// }, 5000);
			}
			this.responseMethod = this.httpClient.get(url, options);
			await (this.spinner.show())
		}
		else if (methodName == 'post')
			this.responseMethod = this.httpClient.post(url, parameter, options);
		else if (methodName == 'put')
			this.responseMethod = this.httpClient.put(url, parameter, options);
		else
			this.responseMethod = this.httpClient.delete(url, options);

		return this.responseMethod.toPromise().then(async (response) => {	//2 Min timeout
			var data: any = response;
			var responseStatus: number;
			var replaceToken: any;
			/* if (methodName == 'get')
				responseStatus = data.status;
			else */
			responseStatus = data.body.status;
			if ((data.headers) && data.headers.get("set-in-auth-token")) {
				/* let tmpUserType = this.cookie.get('userProfile'); */
				let tmpUserType = window.localStorage.getItem('userProfile');
				var getUserType = this.decryptData(tmpUserType);
				/* let tmpUser = this.cookie.get('userType'); */
				let tmpUser = window.localStorage.getItem('userType');
				var getUser = this.decryptData(tmpUser);
				replaceToken = data.headers.get("set-in-auth-token");
				sessionStorage.setItem('token', replaceToken);
				/* this.cookie.set('token', replaceToken); */
				/* window.localStorage.setItem('token', replaceToken); */
				window.localStorage.setItem('auth', this.encryptData(replaceToken));
				window.localStorage.setItem('userProfile', this.encryptData(getUserType));
				window.localStorage.setItem('userType', this.encryptData(getUser));
				/* this.cookie.set('auth', this.encryptData(replaceToken)); */
				/* sessionStorage.setItem('auth', this.commonService.encryptData(replaceToken)); */
				/* this.cookie.set('userProfile', this.encryptData(getUserType));
				this.cookie.set('userType', this.encryptData(getUser)); */
			}
			if (methodName == 'get') {
				data = data.body;
			}
			if (responseStatus == 0 || responseStatus != -114) {
				await (this.spinner.hide());
				return data;
			}
			else if (responseStatus == -114) {
				await (this.spinner.hide());
				if (this.tokenExpiredCount == 0) {
					this.cookie.deleteAll();
					window.localStorage.clear();
					this.errorsmsg('Token expired, please login again', 'Error');
					this.tokenExpiredCount++;
				}
				sessionStorage.clear();
				this.cookie.deleteAll();
				this.router.navigate(['/login', { url: moduleName }]);
				return data;
			}
		}).catch(async err => {
			await (this.spinner.hide());
			if (moduleName != 'Header')
				this.errorsmsg('Server error', 'Error');
			return Promise.reject(err.error || 'Server error');
		});
	}

	/*
	* Created By : Sharann N
	* Description : Numberic validation for input text fields in keypress.
	*********************************************/
	numeric_keyPress(event: any, inputType: any, allowedDecimalDigits = 2) {
		const pattern: any = (inputType == 'pincode') ? this.pincodePattern : (inputType == 'amount' || inputType == 'mfr') ? this.numberPattern : '';
		const inputChar = String.fromCharCode(!event.charCode ? event.which : event.charCode);
		// If the key is backspace, tab, left, right or delete
		if (this.keystobepassedout.indexOf('$' + event.key + '$') != -1) {
			return true;
		}

		//Added by gomathi for two decimal points
		let value = event.target.value; //block first letter is dot
		if (value.length == 0 && event.charCode == 46) {
			event.preventDefault();
			return false;
		}
		// inputType 'mfr' only allow 3 decimal ponits and others allow two deciaml points 
		let decimalChk = (event.target.value.indexOf(".") == -1 ? 0 : 1);
		if (decimalChk) {
			let fieldValue = event.target.value;
			const number = fieldValue.split('.');
			// const numberDeclPattern = inputType == 'mfr' ? /^\s*(?=.*[1-9])\d*(?:\.\d{2})?\s*$/ : /^\s*(?=.*[1-9])\d*(?:\.\d{1})?\s*$/;

			const numberDeclPattern = inputType == 'mfr' ? new RegExp(`^[0-9]{1,11}(?:\.[0-9]{1,9})?$`) : /^\s*(?=.*[1-9])\d*(?:\.\d{1})?\s*$/;
			fieldValue = ((fieldValue && (String(fieldValue)).trim() != '-' && (String(fieldValue)).trim() != '#VALUE?') ? (String(fieldValue)).replace(/,/g, '') : 0);
			if (number[1].length > 0 && number[0].length < event.target.selectionEnd && !numberDeclPattern.test(fieldValue)) {
				event.preventDefault();
				return false;
			}
		}

		if (!pattern.test(inputChar)) {
			// invalid character, prevent input
			event.preventDefault();
			return false;
		}

	}

	/* numeric_keyPress(event: any, inputType: any, htmlId: any = '') {
        const pattern: any = (inputType == 'pincode') ? this.pincodePattern : (inputType == 'amount' || inputType == 'mfr') ? this.numberPattern : '';
        const inputChar = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        // If the key is backspace, tab, left, right or delete
        if (this.keystobepassedout.indexOf('$' + event.key + '$') != -1) {
            return true;
        }

		//Added by gomathi for two decimal points
		let value = event.target.value; //block first letter is dot
		if (value.length == 0 && event.charCode == 46) {
			event.preventDefault();
			return false;
		}
		//allow two decimal points
		let decimalChk = (event.target.value.indexOf(".") == -1 ? 0 : 1);
		if (decimalChk) {
			var number = event.target.value.split('.');
			if (number[1].length > 1) {
				event.preventDefault();
				return false;
			}
		}

		if (!pattern.test(inputChar)) {
			// invalid character, prevent input
			event.preventDefault();
			return false;
		}

	} */
	/*
	* Created By : Sharann N
	* Description : Alphanumberic with and without white-space validation for input text fields in keypress.
	*********************************************/
	alphanumeric_keyPress(event: any, isSpaceAllowed: boolean = false) {
		const pattern: any = isSpaceAllowed ? this.alphaNumbericWithSpacePattern : this.alphaNumbericPattern;
		const inputChar = String.fromCharCode(!event.charCode ? event.which : event.charCode);
		// If the key is backspace, tab, left, right or delete
		if (this.keystobepassedout.indexOf('$' + event.key + '$') != -1) {
			return true;
		}
		if (!pattern.test(inputChar)) {
			// invalid character, prevent input
			event.preventDefault();
			return false;
		}
	}

	/*
	* Created By : Keerthana
	* Description : it returns the success toastr message.
	*********************************************/
	successmsg(message: string, messageType: string) {
		this.toastr.success(message);
	}

	/*
	* Created By : Keerthana
	* Description : it returns the failure or error toastr message.
	*********************************************/
	errorsmsg(message: string, messageType: string) {
		this.toastr.error(message);
	}

	/*
	* Created By : Keerthana
	* Description : it returns the warning toastr message.
	*********************************************/
	warningmsg(message: string, messageType: string) {
		this.toastr.warning(message);
	}

	/*
	* Created By : Sharann N
	* Description : check the first invalid field in reactive form.
	*********************************************/
	checkInvalidFormField(formName: FormGroup) {
		for (const key of Object.keys(formName.controls)) {
			if (formName.controls[key].invalid) {
				return key;
			}
		}
		return false;
	}

	async deleteAlertMsg() {
		var deleteStatus;
		await (Swal.fire({
			text: 'Do you want to delete the record !',
			showCancelButton: true,
			confirmButtonText: ' <span style="font-weight:normal">Yes</span>',
			cancelButtonText: '<span style="font-weight:normal">No</span>'
		}).then((result) => {
			if (result.value) {
				deleteStatus = true
			} else if (result.dismiss === Swal.DismissReason.cancel) {
				deleteStatus = false
			}
		}));
		return deleteStatus;
	}

	/*
	* Created By : Sureshkumar Selvaraj
	* Description : find the policy status
	*********************************************/
	async findCertificateStatus(policyData) {
		let status = "Draft";

		if (policyData.quote.cust_fld_10 == "2" || (policyData.cancel_certificate_request || '').toLowerCase() == 'yes' || policyData.status == 1) {
			return "Cancelled-Certificate";
		}

		else if (policyData.quote.cust_fld_10 == "3") {
			return "Rejected-Cancellation";
		}

		const idx = policyData.qnstp.details.length;
		const nstp_status = idx ? policyData.qnstp.details[idx - 1].nstp_status : '';

		if (policyData.policy_no) {
			if ((policyData.endrosement || []).length && policyData.assigned_to != policyData.created_by) {
				let tmpIndex = policyData.endrosement.length;
                 //compare code start
 				if ((policyData.endrosement[tmpIndex - 1].endrosement_no == null || '') && policyData.endrosement[tmpIndex - 1].assigned_to != policyData.endrosement[tmpIndex - 1].created_by) {
 					status = 'Referred-Certificate';
 				}
 				else {
 					status = 'Issued';
 				}
			} else {
				status = 'Issued';
			}
		} else {
			if (((policyData.quote.data.nstpyn || '').toLowerCase() === 'yes' && nstp_status == '') || policyData.quote.data.referral_type == "Draft Deletion") {
				status = 'On-Hold-Draft';
			}
		}
//compare code end
		return status;


	}

	/*
	* Created By : Sharann N
	* Description : Regex validation in keypress.
	*********************************************/
	regex_keyPress(event, pattern: RegExp = this.alphaNumbericWithSpacePattern) {
		const inputChar = String.fromCharCode(!event.charCode ? event.which : event.charCode);
		// If the key is backspace, tab, left, right or delete
		if (this.keystobepassedout.indexOf('$' + event.key + '$') != -1) {
			return true;
		}
		if (!pattern.test(inputChar)) {
			// invalid character, prevent input
			event.preventDefault();
			return false;
		}
	}


	/*
	* Created By : Sharann N
	* Description : send mail in declaration module.
	*********************************************/
	async sendDeclarationMail(params) {
		const url = `${this.commonVariablesService.baseURL}api/v1/marine_declaration/email`;
		const response = await this.httpPostMethod(url, params, 'application/json', true, 'Declaration');
		return response;
	}

	/*
	* Created By : Sharann N
	* Description : to check input is null or not
	*********************************************/
	checkNull(stringVal) {
		if (stringVal === null || stringVal === undefined || stringVal === '' || stringVal == "undefined" || stringVal == "null") {
			return true;
		} else {
			return false;
		}
	}


	/*
	* Created By : Sharann N
	* Description : to get pdf as blob
	*********************************************/
	getPdf(url, isImpersonate, isLoggedIn: boolean = true) {

		const httpOptions = {
			responseType: 'blob' as 'json',
			headers: new HttpHeaders(
				isLoggedIn ? {
					/* 'in-auth-token': (isImpersonate) ? sessionStorage.getItem('imp_token') : sessionStorage.getItem('token'), */
					/* 'in-auth-token': (isImpersonate) ? window.localStorage.getItem('imp_token') : window.localStorage.getItem('token'), */
					'in-auth-token': (isImpersonate) ? sessionStorage.getItem('imp_token') : sessionStorage.getItem('token'),
				} : {}
			)
		};
		return this.httpClient.get(url, httpOptions);
	}

	/*
	* Created By : Sharann N
	* Description : to get master policy endorsement details
	*********************************************/
	async getMasterEndorsement(gcPolicyNo,renewalCounter) {
		let ret: any = [];
		if (gcPolicyNo) {
			const url = `${this.commonVariablesService.baseURL}api/v1/marine_mp_gc_data/fetch_policies`;
			const paramData = {
				policy_number: gcPolicyNo,
				renewal_counter: renewalCounter
			};
			const response = await this.httpGetMethod(url, 'application/json', true, paramData, 'Declaration');
			if (response.status != 0) {
				this.errorsmsg(response.txt || 'Unable to get master policy endorsment', '');
			}
			ret = (response.status == 0) ? (response.data || []) : [];
			let details = [];
			let allPolicyrefNum = ''
			let tmp = {};
			for (let obj of ret) {
				if(allPolicyrefNum == '')
					allPolicyrefNum = obj.policy_ref_num;
				else
					allPolicyrefNum = allPolicyrefNum +','+ obj.policy_ref_num;
				if (obj.policy_number) {
					for (let voyageObj of obj.voyage) {
						for (let upldObj of obj.uploaded_data) {
							if (voyageObj.gc_running_id == upldObj.gc_running_id) {
								tmp = {
									...obj,
									['master_policy_no']: upldObj.policy_no,
									['policy_no']: upldObj.policy_no,
									['cust_fld_3']: obj.policy_ref_num,
									data: {
										portal_lock_date: obj['portal_lock_date'],
										client_users: voyageObj['client_users'],
										producer_users: voyageObj['producer_users'],
										sub_voyage: voyageObj['sub_voyage'] || []
									},
									quote: {
										data: {
											...obj,
											['voyage']: voyageObj,
											['policy_id']: upldObj.insillion_policy_id,
											['master_policy_no']: upldObj.policy_no,
											['gc_policy_start_date']: obj.endorsement_start_date || obj.policy_inception_date,
											['gc_policy_end_date']: obj.policy_expiry_date,
											['premium_value']: voyageObj.net_premium
										}
									}
								}
								break;
							}
						}
						details.push({ ...tmp });
					}
				}
			}
			ret = details;
			window.localStorage.setItem('allPolicyrefNum',allPolicyrefNum)
		}
		this.isGcHavingEndorsement = (ret.length > 0) ? true : false;
		return ret;
	}

	/*
	* Created By : Sharann N
	* Description : to get selected master policy details from total endorsement data
	*********************************************/
	async getSelectedGcData(declarationForm: any, gcEndorsementDetails, isCertificate) {
		// const date: any = new Date(declarationForm.expected_date_shipment.value);
		const date: any = new Date(new Date(declarationForm.expected_date_shipment.value).toLocaleDateString());
		const header = JSON.parse(window.localStorage.getItem('declaration-header') || '{}');
		let details = [];
		let prevMinDate = 0;
		let selectedIdx = [];
		
		if (this.isGcHavingEndorsement) {
			for (const [idx, obj] of (gcEndorsementDetails || []).entries()) {
				// let policyStartDate: any = new Date(obj.endorsement_start_date || obj.policy_inception_date);
				let policyStartDate: any = new Date(new Date(obj.endorsement_start_date || obj.policy_inception_date).toLocaleDateString());
				for (const [subIdx, subVoyageObj] of (obj.data.sub_voyage || []).entries()) {
					const quoteData = obj.quote.data;
					const diffDates = Math.floor(((policyStartDate - date) / (1000 * 60 * 60 * 24)));
					if (idx == 0 && subIdx == 0) {
						prevMinDate = diffDates;
					}
					// (idx == 0 && subIdx == 0) ? prevMinDate = diffDates : '';
					// Renewal Counter
                    if (obj.policy_code == 'RC' && obj.policy_ref_num == header.policy_ref_num) {
                        prevMinDate = diffDates;
                    }
					const voyageName = await this.getVoyageDesc(quoteData.voyage);
					const days = subVoyageObj.days_post_expiry;
					const dateObj = new Date(quoteData.gc_policy_end_date);
					dateObj.setDate(dateObj.getDate() + Number(days));
					const isNotExpiried = new Date().getTime() <= dateObj.getTime() ? true : false;
					const isMop = ((quoteData.policy_type || '').toUpperCase() == "MOP" || (quoteData.policy_type || '').toUpperCase() == "OPEN COVER") ? true : false;
					const isRateApplicable = ((quoteData.voyage.rate_applicable).toUpperCase() == 'YES') ? true : false;

					// if ((isNotExpiried && ((!isMop && subVoyageObj.certificate_allowed == "Yes" && isCertificate) || (!isMop && isRateApplicable && !isCertificate) || (isMop && subVoyageObj.certificate_bulk == "Certificate" && header.sub_voyage_id == subVoyageObj.id && isCertificate) || (isMop && subVoyageObj.certificate_bulk != "Certificate" && !isCertificate))) && prevMinDate <= diffDates && ((obj.policy_code == 'RC') || diffDates < 1))

					if ((isNotExpiried && ((!isMop && subVoyageObj.certificate_allowed == "Yes" && isCertificate)
                        || (!isMop && isRateApplicable && !isCertificate)
						|| (isMop && subVoyageObj.certificate_bulk == "Certificate" && isCertificate)
                        || (isMop && subVoyageObj.certificate_bulk != "Certificate" && !isCertificate))
					) && prevMinDate <= diffDates && ((obj.policy_code == 'RC') || diffDates < 1)) {
						prevMinDate = diffDates;
						(selectedIdx.indexOf(idx) == -1) ? selectedIdx.push(idx) : '';
					}
				}
			}
			if ((gcEndorsementDetails || []).length) {
				// // Ticket No : 176527 Same voyage name changes start 
				if(declarationForm.risk_details.value) {
					gcEndorsementDetails.forEach(data => {
						data.data.sub_voyage.forEach(element => {
							element.risk_detail_serial = data?.quote?.data?.voyage?.risk_detail_serial;
						});
					});

					// Ticket No : 176527 Same voyage name changes end
				for(const selectedId of selectedIdx){
					// Ticket No : 176527 Same voyage name changes start 
					for (const subVoyageObj of gcEndorsementDetails[selectedId].data.sub_voyage) {
						if (subVoyageObj.voyage_name == declarationForm.voyage_name.value && subVoyageObj.sub_voyage_name == declarationForm.sub_voyage_type.value && subVoyageObj.risk_detail_serial === declarationForm.risk_details.value) {
							details = [{
								...gcEndorsementDetails[selectedId],
								data: {
									...gcEndorsementDetails[selectedId].data,
									sub_voyage: [{ ...subVoyageObj }]
								}
							}];
							break;
						}
						
					}
				}
				} else if(declarationForm.gc_running_id.value) {
					gcEndorsementDetails.forEach(data => {
						data.data.sub_voyage.forEach(element => {
							element.gc_running_id = data?.quote?.data?.voyage?.gc_running_id;
						});
					});

					// Ticket No : 176527 Same voyage name changes end
				for(const selectedId of selectedIdx){
					// Ticket No : 176527 Same voyage name changes start 
					for (const subVoyageObj of gcEndorsementDetails[selectedId].data.sub_voyage) {
						if (subVoyageObj.voyage_name == declarationForm.voyage_name.value && subVoyageObj.sub_voyage_name == declarationForm.sub_voyage_type.value && subVoyageObj.gc_running_id === declarationForm.gc_running_id.value) {
							details = [{
								...gcEndorsementDetails[selectedId],
								data: {
									...gcEndorsementDetails[selectedId].data,
									sub_voyage: [{ ...subVoyageObj }]
								}
							}];
							break;
						}
						
					}
				}
				} else {
					for(const selectedId of selectedIdx){
						// Ticket No : 176527 Same voyage name changes start 
						for (const subVoyageObj of gcEndorsementDetails[selectedId].data.sub_voyage) {
							if (subVoyageObj.voyage_name == declarationForm.voyage_name.value && subVoyageObj.sub_voyage_name == declarationForm.sub_voyage_type.value) {
								details = [{
									...gcEndorsementDetails[selectedId],
									data: {
										...gcEndorsementDetails[selectedId].data,
										sub_voyage: [{ ...subVoyageObj }]
									}
								}];
								break;
							}
							
						}
					}
				}
			}
		}
		return details;
	}

	/*
	* Created By : Sharann N
	* Description : to convert word to past tense
	*********************************************/
	async convertToPastTense(word) {
		return ((word.slice(-1) != '-' && word.slice(-1) != 'd') ? word.slice(-1) != 'e' ? `${word}ed` : `${word}d` : word);
	}

	/*
	* Created By : Sharann N
	* Description : for preview of pdf
	*********************************************/
	async previewPdf(url, isImpersonate, isLoggedIn) {
		this.spinner.show();
		return new Promise(async resolve => {
			await this.getPdf(url, isImpersonate, isLoggedIn).subscribe(async (data: any) => {
				const pdfData = data;
				const target = '_blank';
				if ((pdfData.type || '') == 'application/pdf') {
					var pdfUrl = window.URL.createObjectURL(pdfData);
					/* return url; */
					var anchor = document.createElement('a');
					anchor.href = pdfUrl;
					anchor.target = target;
					/* var popUp = window.open(url, target);
					if (popUp == null || typeof (popUp) == 'undefined') {
						popUp.close();
						this.spinner.hide();
						resolve({ status: -2, data: 'Please disable your pop-up blocker and click the "Open" link again.'});
					} else {
						anchor.click();
						this.spinner.hide();
						resolve({ status: 0, data: url });
					} */
					this.spinner.hide();
					resolve({ status: 0, data: pdfUrl });
				} else {
					this.spinner.hide();
					resolve({ status: -3, data: 'Unable to load pdf' });
				}
			}, error => {
				this.spinner.hide();
				resolve({ status: -1, data: 'Unable to load pdf' });
			});
		});
	}

	/*
	* Created By : Sharann N
	* Description : for download pdf
	*********************************************/
	downloadPdf(type, data) {
		if (data.is_original_downloaded && type == 'policy-original') {
			this.errorsmsg('Original PDF is already downoaded', '');
			this.spinner.hide();
		} else {
			this.spinner.show();
			const url = `${this.commonVariablesService.baseURL}api/v1/marine_declaration/certificate_pdf?${(data.eproposal_id) ? `endorsement_id=${data.endorsement_id}${(type == 'policy-original') ? '&pdf_type=original' : ''}` : `${(type == 'draft') ? `quote_id=${data.quote_id}` : `policy_id=${data.policy_id}`}${(type == 'policy-original') ? '&pdf_type=original' : ''}`}`;
			return new Promise(async resolve => {
				await this.getPdf(url, false).subscribe(async (pdfData: any) => {
					const blob = ((pdfData.type || '') == 'application/pdf') ? pdfData : new Blob([pdfData], { type: 'application/pdf' });
					var downloadURL = window.URL.createObjectURL(blob);
					var link = document.createElement('a');
					link.href = downloadURL;
					link.download = `${((type == 'draft') ? 'Draft-' : 'Policy-') + data.certificate_no}.pdf`;
					link.click();
					resolve({ status: 0, data: downloadURL });
				}, error => {
					this.spinner.hide();
					resolve({ status: -1, data: 'Unable to load pdf' });
				}
				);
			});
		}
	}

	/*
	* Created By : Sharann N
	* Description : navigate to declaration page.
	*********************************************/
	async navigateToDecl(pageId) {
		if (pageId == 0 || pageId == 1) {
			this.objectSelector.next({ id: pageId })
		}
		// (pageId == 0 || pageId == 1) ? this.objectSelector.next({ id: pageId }) : '';
		this.router.navigate(['/declaration', pageId]);
	}

	/*
	* Created By : Sharann N
	* Description : add voyage description with voyage name.
	*********************************************/
	async getVoyageDesc(voyageDetails) {
		let ret = '';
		if ((voyageDetails || {}).voyage_name) {
			ret = (voyageDetails.voyage_description && (voyageDetails.voyage_name || '').toUpperCase() == "OTHERS") ? `${voyageDetails.voyage_name} (${voyageDetails.voyage_description})` : voyageDetails.voyage_name;
		}
		return ret;
	}

	/*
	* Created By : Sharann N
	* Description : remove voyage description with voyage name.
	*********************************************/
	async removeVoyageDesc(voyageNameWithDesc) {
		return (voyageNameWithDesc || '').split('(')[0].trim();
	}
	/*
	* Created By : Sharann N
	* Description : To get product id's and user id's.
	*********************************************/
	async commonLOBvalues() {
		let count = 0;
		let param = {
			status: "0"
		}
		let policyProductURL = this.commonVariablesService.baseURL + 'api/v1/master/marine_product_id_mp';
		let coiProductURL = this.commonVariablesService.baseURL + 'api/v1/master/marine_product_id_coi';
		let uw1URL = this.commonVariablesService.baseURL + 'api/v1/master/marine_uw_id_level1';
		let uw2URL = this.commonVariablesService.baseURL + 'api/v1/master/marine_uw_id_level2';
		let uw3URL = this.commonVariablesService.baseURL + 'api/v1/master/marine_uw_id_level3';
		let helpdeskURL = this.commonVariablesService.baseURL + 'api/v1/master/marine_help_desk_id';
		let policyProductResponse = await this.httpGetMethod(policyProductURL, '', true, param, 'Common')
		let coiProductResponse = await this.httpGetMethod(coiProductURL, '', true, param, 'Common')
		let uw1Response = await this.httpGetMethod(uw1URL, '', true, param, 'Common')
		let uw2Response = await this.httpGetMethod(uw2URL, '', true, param, 'Common')
		let uw3Response = await this.httpGetMethod(uw3URL, '', true, param, 'Common')
		let helpdeskResponse = await this.httpGetMethod(helpdeskURL, '', true, param, 'Common')
		if (policyProductResponse.status == 0 && policyProductResponse.data.length > 0) {
			this.commonVariablesService.productId = policyProductResponse.data[0].name;
			count++;
		}
		if (coiProductResponse.status == 0 && coiProductResponse.data.length > 0) {
			this.commonVariablesService.declarationProductId = coiProductResponse.data[0].name;
			count++;
		}
		if (uw1Response.status == 0 && uw1Response.data.length > 0) {
			this.commonVariablesService.uwLOneGrpCode = uw1Response.data[0].name;
			count++;
		}
		if (uw2Response.status == 0 && uw2Response.data.length > 0) {
			this.commonVariablesService.uwLTwoGrpCode = uw2Response.data[0].name;
			count++;
		}
		if (uw3Response.status == 0 && uw3Response.data.length > 0) {
			this.commonVariablesService.uwLThreeGrpCode = uw3Response.data[0].name;
			count++;
		}
		if (helpdeskResponse.status == 0 && helpdeskResponse.data.length > 0) {
			this.commonVariablesService.helpdeskGrpCode = helpdeskResponse.data[0].name;
			count++;
		}
		if (count == 6)
			return true;
		else
			return false;
	}

	/*
	* Created By : Sharann N
	* Description : To check master policy is expired or not.
	*********************************************/
	async checkPolicyExpiredOrNot(endDate, postDays) {
		/* const tmpUserType = this.cookie.get('userProfile'); */
		const tmpUserType = window.localStorage.getItem('userProfile');
		let getUserType = this.decryptData(tmpUserType);
		getUserType = (getUserType || '').toLowerCase();
		let date: any = new Date(endDate);
		let currentDate: any = new Date();
		// add post_days_expiry to policy end date
		date.setDate(date.getDate() + Number(postDays));
		const diffDays = Math.floor((date - currentDate) / (1000 * 60 * 60 * 24));
		const isInvalid = (getUserType == 'hub' || getUserType == 'admin' || getUserType == 'underwriter') ? false : (diffDays < 0);
		if (isInvalid) {
			this.errorsmsg('Policy has been expired', '');
		}
		// will return 'true' or 'false' based on condition
		return isInvalid;
	}

	/*
	* Created By : Sharann N
	* Description : To form the dropdown array in header.
	*********************************************/
	async formMasterPolicyList(moduleName) {
		await (this.spinner.show());
		let url = `${this.commonVariablesService.baseURL}api/v1/marine_declaration/master_policy`;
		const paramData = {
			product_id: this.commonVariablesService.declarationProductId,
			is_list: 1,
			gc_policy_no: this.commonVariablesService.gcPolicyNoFromHeaderSearch
		}
		let response = await this.httpGetMethod(url, "application/json", true, paramData, moduleName);
		await (this.spinner.show());
		let array = (response.status == 0) ? (response.data || []) : [];
		array = Array.from(new Set(array.map(a => ((a.data.quote.data || {}).policy_ref_num || ''))))
			.map(id => {
				return (array.find(a => (((a.data.quote.data || {}).policy_ref_num || '') != '' && ((a.data.quote.data || {}).policy_ref_num || '') === id && a.data.cust_fld_10 == "1")) || {
					cust_fld_1: '',
					cust_fld_4: '',
					quote: {
						data: {
							insured_name: '',
							insured_city: '',
							policy_ref_num: ''
						}
					}
				})
			});
		array.forEach((obj, index) => {
			obj["search_val"] = ((obj.data.quote.data || {}).insured_name || '') + '~$' + (obj.data.cust_fld_1 || '') + '~$' + ((obj.data.quote.data || {}).insured_city || '');
			obj["cust_fld_4"] = ((obj.data.quote.data || {}).insured_name || '');
			obj["cust_fld_1"] = (obj.data.cust_fld_1 || '');
			obj["branch"] = ((obj.data.quote.data || {}).insured_city || '-');
			obj["policy_ref_num"] = ((obj.data.quote.data || {}).policy_ref_num || '');
			obj["status"] = (obj.data.status || 0);
			obj["policy_start_date_dt"] = ((obj.data.quote.data || {}).gc_policy_start_date || '');
			obj["policy_end_date_dt"] = ((obj.data.quote.data || {}).gc_policy_end_date || '');
			obj["policy_end_date_endorsement"] = ((obj.data.quote.data || {}).gc_policy_end_date_list || '');
			obj["renewal_counter"] = (obj.data.renewal_counter || '000').slice(-2);
			obj["actual_renewal_counter"] = (obj.data.renewal_counter || '000');
		});
		await (this.spinner.hide());
		var x = document.getElementById('btnChannelTypeSubmit');
			if(x !== null) {
				x.setAttribute('disabled','true')


				setTimeout(() => {
					x.removeAttribute('disabled')
				}, 4000);
			}
		this.gcPolicyList = array;
		return array;
	}


	/*
	* Created By : Sharann N
	* Description : To format date.
	*********************************************/
	async formatDate(date, format) {
		const ret = date == 'Invalid date' ? '-' : this.datePipe.transform(date, format);
		return await ret;
	}

	/*
	* Created By : Sharann N
	* Description : to get policy start date
	*********************************************/
	async getPolicyStartDate(gcRunningId, gcData, header) {
		let ret = [];
		loop:
		for (const dataObj of gcData) {
			if (dataObj.quote.data.voyage.gc_running_id == gcRunningId&& dataObj.policy_ref_num == header.policy_ref_num) {
				ret.push({
					...dataObj
				});
				break loop;
			}
		}
		return ret;
	}
	/*
	* Created By : Vishnuraj 
	* Description : For Tagic user profile Api
	*********************************************/
	async profileLogin(url, headers) {
		return await this.httpClient.get(url, {
			headers: headers,
			observe: 'response'
		}).toPromise();
	}

	/*
	* Created By : Sharann N
	* Description : to send low balance trigger
	*********************************************/
	async lowBalanceTriggerMail(params) {
		const url = `${this.commonVariablesService.baseURL}api/v1/marine_mailer/send_mail/low_balance_trigger`;
		const response = await this.httpPostMethod(url, params, 'application/json', true, 'Declaration');
		return response;
	}

	/*
	* Created By : Sharann N
	* Description : to set certificate data in localstorage
	*********************************************/
	async setCertificateParmsToLStorage(params) {
		let selected = params.value ? params.value.split('~$')[1] : "";
		let searchContent = params.value.split('~$') || ['-', '-', '-', '-'];
		let declarationHeader: any = {};
		declarationHeader.insured_name = searchContent[0] || '-';
		declarationHeader.tp_policy_no = searchContent[1] || '-';
		declarationHeader.insured_city = searchContent[2] || '-';
		declarationHeader.policy_ref_num = params.item.policy_ref_num || '-';
		declarationHeader.header_policy = selected;
		declarationHeader.sub_voyage_id = params.item.data.data.sub_voyage[0].id; //Added by gomathi
		declarationHeader.policy_no = params.item.data.policy_no;
		declarationHeader.policy_start_date_dt = params.item.policy_start_date_dt;
		declarationHeader.policy_end_date_dt = params.item.policy_end_date_dt;
		declarationHeader.policy_end_date_endorsement = params.item.policy_end_date_endorsement;
		declarationHeader.renewal_counter = params.item.renewal_counter;
		declarationHeader.actual_renewal_counter = params.item.actual_renewal_counter;
		// declarationHeader.masterpolicy_status = e.item.status; //Added by sharann
		window.localStorage.setItem('declaration-header', JSON.stringify(declarationHeader));
	}
	
	/*
	* Created By : Sharann N
	* Description : get date obj from excel date.
	*********************************************/
	excelDateToJSDate(serial) {
		return new Promise(async resolve => {
			const utc_days = Math.floor(serial - 25569);
			const utc_value = utc_days * 86400;
			const date_info = new Date(utc_value * 1000);
			const fractional_day = serial - Math.floor(serial) + 0.0000001;
			let total_seconds = Math.floor(86400 * fractional_day);
			const seconds = total_seconds % 60;
			total_seconds -= seconds;
			const hours = Math.floor(total_seconds / (60 * 60));
			const minutes = Math.floor(total_seconds / 60) % 60;	
			// return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
			return resolve(new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds));
		});
	}

	/*
	* Created By : Sharann N
	* Description : find tax applicable.
	*********************************************/
	taxApplicableStatus(tax) {
		return (isNaN(tax || 0) ? tax : ((tax || 0) > 0) ? 'Yes' : 'No');
	}
	
}